module.exports = __webpack_public_path__ + "img/3k-logo.0ac8e226.svg";